import gql from "graphql-tag";

export const SAVE_DEFAULT_SPECS_MUTATION = gql`
  mutation SaveDefaultSpecs(
    $projectId: SmartID!
    $serviceId: SmartID!
    $specList: [SpecsObject!]!
  ) {
    addDefaultSpecs(
      projectId: $projectId
      serviceId: $serviceId
      specList: $specList
    ) {
      success
      message
    }
  }
`;
